// extracted by mini-css-extract-plugin
export default {"partnersList":"PartnersList_partnersList__OW7pp"};